<template>
  <Layout>
    <template #default>
      <div class="container-fluid p-0 m-0 background1">
        <div class="row bg-Hellgrau pt-3 pb-3 justifyCenter" id="t0">
          <div class="col-md-4 t-center spacebetween">
            <div class="div borderRund rundKopf">
              <a href="#t0">
                <h5 v-if="sprachID === 0">Jahreshauptversammlung</h5>
                <h5 v-if="sprachID === 1">annual general meeting</h5>
              </a>
            </div>
            <div class="div borderRund rundKopf">
              <a href="#t1">
                <h5 v-if="sprachID === 0">Herbsttagung</h5>
                <h5 v-if="sprachID === 1">autumn conference</h5>
              </a>
            </div>
          </div>
        </div>
        <div class="row bg-Hellgrau pt-3 pb-3 justifyCenter">
          <div class="col-md-8 t-center text-Weiss" v-if="sprachID === 0">
            Jährlich finden zwei Tagungen statt, im Frühjahr und im Herbst.
            <br />
            Die Frühjahrstagung ist gleichzeitig auch Jahreshauptversammlung der
            Mitglieder des AfM.
          </div>
          <div class="col-md-8 t-center text-Weiss" v-if="sprachID === 1">
            Two conferences are held each year, in spring and autumn. <br />
            The spring conference is also the annual general meeting of the Members of the
            AfM.
          </div>
        </div>

        <div class="row justifyCenter bg-WeissTransparent" id="t0">
          <div class="col-md-10 t-center aussendiv text-Rot-Schatten">
            <div class="pt-5 pb-5">
              <span class="text-Rot-Schatten" v-if="sprachID === 0"
                >Jahreshauptversammlung</span
              >
              <span class="text-Rot-Schatten" v-if="sprachID === 1"
                >annual general meeting</span
              >
            </div>
          </div>
        </div>

        <div class="row justifyCenter pb-5 bg-WeissTransparent">
          <div class="col-md-6 text-center">
            Informationen zur Jahreshauptversammlung 2027 werden rechtzeitig bekannt gegeben.
          </div>
        </div>

        <div class="row justifyCenter bg-WeissTransparent" id="t1">
          <div class="col-md-10 t-center aussendiv text-Rot-Schatten">
            <div class="pt-5 pb-5">
              <span class="text-Rot-Schatten" v-if="sprachID === 0">Herbsttagung</span>
              <span class="text-Rot-Schatten" v-if="sprachID === 1"
                >autumn conference</span
              >
            </div>
          </div>
        </div>

        <div class="row justifyCenter pb-5 bg-WeissTransparent">
          <div class="col-md-6 text-center">
           <p>Herbsttagung 2026 in Wächtersbach/Aufenau 02. – 04.10.2026</p> 
          </div>
        </div>

        <div class="row justifyCenter pb-5 bg-WeissTransparent">
        <div class="col-md-6 text-center">
          <p>Liebe AƒM-ler,</p>
          <p>zur Herbsttagung 2026 des Arbeitskreises für Mammillarienfreunde
          e. V. möchte ich Sie herzlich in den „Landgasthof zur Quelle“ in
          Wächtersbach/Aufenau einladen, wo schon die Tagungen 2018, 2022 und 2024
          stattgefunden haben.</p>
          <p>Der Termin ist der 02. – 04.10.2026</p>
          <p>Zwischen Bad Orb und
          Bad Soden-Salmünster liegt an der Deutschen Märchenstraße, mit herrlichem Blick
          in das schöne Kinzigtal, der kleine Ort Aufenau. Es ist ein idealer
          Ausgangspunkt für Ausflüge in die Region.</p>
            <p class="borderRund"
            @click="openPDF('Vuepdf/Mtbl 50-1-2026_Einladung_Herbsttagung_V1.pdf')">
            <span class="bold" v-if="sprachID === 0">Einladungsschreiben</span>
            <span class="bold" v-if="sprachID === 1">invitation letter</span>
              
            </p>
        </div>
      </div>
      </div>
    </template>
  </Layout>
</template>

<script>
import Layout from "@/layouts/Layout";
import { openModal } from "jenesius-vue-modal";
import modalPDF from "../components/ModalPDF.vue";

export default {
  name: "Praxis",

  data() {
    return {
      newSite: null,
    };
  },
  components: {
    Layout,
  },
  methods: {
    openPDF(pdf) {
      const props = { pdf: pdf };
      openModal(modalPDF, props);
    },
  },
  computed: {
    sprachID() {
      let sprachID = this.$store.getters.getSprachID;
      return sprachID;
    },
  },
};
</script>

<style scoped>
.list-group-item {
  background-color: transparent;
  border: none;
}
</style>
